import React from 'react';
import PropTypes from 'prop-types';

import Row from './Row';
import styles from './index.module.css';

const TableDesktop = ({ withdrawals }) => (
  <div className={styles.tableDesktop}>
    <table className={styles.table}>
      <thead className={styles.tableHeading}>
        <tr>
          <th className={styles.tableHeadingCell}>Date</th>
          <th className={styles.tableHeadingCell}>Wallet</th>
          <th className={styles.tableHeadingCellNetwork}>Network</th>
          <th className={styles.tableHeadingCellRight}>Amount</th>
          <th className={styles.tableHeadingCellRight}>Status</th>
        </tr>
      </thead>
      <tbody>
        {withdrawals.map((withdrawal) => (
          <Row key={withdrawal.id} withdrawal={withdrawal} />
        ))}
      </tbody>
    </table>
  </div>
);

TableDesktop.propTypes = {
  withdrawals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TableDesktop;
